import { render, staticRenderFns } from "./last_saved.vue?vue&type=template&id=78f4d346&scoped=true&"
import script from "./last_saved.vue?vue&type=script&setup=true&lang=ts&"
export * from "./last_saved.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./last_saved.vue?vue&type=style&index=0&id=78f4d346&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4d346",
  null
  
)

export default component.exports